import React from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { DATE_FORMAT_WEB, DATETIME_FORMAT_ISO } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';

const HotelSection = ({
  currentSelectedFlight,
  setCurrentSelectedFlight,
  validationFlightFormErrors,
  setValidationFlightFormErrors,
  isHotelNeeded,
  ticketStatus,
}) => {
  if (!isHotelNeeded) return null;

  return (
    <>
      <hr />
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Hotel Name</Form.Label>
          <Form.Control
            type="text"
            value={currentSelectedFlight.hotelName || ''}
            onChange={(e) => {
              setValidationFlightFormErrors({});
              setCurrentSelectedFlight({
                ...currentSelectedFlight,
                hotelName: e.target.value,
              });
            }}
            isInvalid={!!validationFlightFormErrors.hotelName}
          />
          <Form.Control.Feedback type="invalid">{validationFlightFormErrors.hotelName}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Check-in Date</Form.Label>
          <Datetime
            timeFormat={false}
            dateFormat={DATE_FORMAT_WEB}
            closeOnSelect
            utc={true}
            inputProps={{ placeholder: DATE_FORMAT_WEB }}
            value={DateTimeFormater(currentSelectedFlight.hotelCheckInDate, null, DATE_FORMAT_WEB)}
            onChange={(e) => {
              setValidationFlightFormErrors({});
              setCurrentSelectedFlight({
                ...currentSelectedFlight,
                hotelCheckInDate: DateTimeFormater(e, null, DATETIME_FORMAT_ISO),
              });
            }}
          />
          {validationFlightFormErrors.hotelCheckInDate && (
            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
              {validationFlightFormErrors.hotelCheckInDate}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col} hidden={(ticketStatus || '').toLowerCase().trim() !== 'pendingbtt'}>
          <Form.Label>Check-out Date</Form.Label>
          <Datetime
            timeFormat={false}
            dateFormat={DATE_FORMAT_WEB}
            closeOnSelect
            utc={true}
            inputProps={{ placeholder: DATE_FORMAT_WEB }}
            value={DateTimeFormater(currentSelectedFlight.hotelCheckOutDate, null, DATE_FORMAT_WEB)}
            onChange={(e) => {
              setValidationFlightFormErrors({});
              setCurrentSelectedFlight({
                ...currentSelectedFlight,
                hotelCheckOutDate: DateTimeFormater(e, null, DATETIME_FORMAT_ISO),
              });
            }}
          />
          {validationFlightFormErrors.hotelCheckOutDate && (
            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
              {validationFlightFormErrors.hotelCheckOutDate}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>
    </>
  );
};

HotelSection.propTypes = {
  currentSelectedFlight: PropTypes.object.isRequired,
  setCurrentSelectedFlight: PropTypes.func.isRequired,
  validationFlightFormErrors: PropTypes.object.isRequired,
  setValidationFlightFormErrors: PropTypes.func.isRequired,
  isHotelNeeded: PropTypes.bool.isRequired,
  ticketStatus: PropTypes.string,
};

export default HotelSection;
